import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import {
  Credencial,
  FirmaElectronica,
  ListaCorreo,
  User,
  UserPhoto,
} from "../models/User";
import { Observable, catchError, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdministrationService {
  private GET_CURRENT_USER_DATA_URL = environment.apiUrl + "a/u/i";
  private PUT_CURRENT_USER_DATA_URL = environment.apiUrl + "a/u";
  private GET_CURRENT_USER_PHOTO = environment.apiUrl + "a/u/i/f";
  private PUT_CURRENT_USER_PHOTO = environment.apiUrl + "a/u/f";
  private GET_CURRENT_USER_MINIATURE_URL = environment.apiUrl + "a/u/i/m";
  private PUT_CURRENT_USER_PASSWORD_URL = environment.apiUrl + "a/u/c";
  private GET_CURRENT_USER_SIGNATURE_DATA_URL = environment.apiUrl + "a/u/fe";
  private PATCH_CURRENT_USER_SIGNATURE_URL = environment.apiUrl + "a/u/fe";

  constructor(private httpClient: HttpClient) {}

  GetCurrentUserData(): Observable<User> {
    return this.httpClient.get<User>(this.GET_CURRENT_USER_DATA_URL);
  }

  UpdateCurrentUserData(user: User): Observable<User> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.httpClient.put<User>(this.PUT_CURRENT_USER_DATA_URL, user, {
      headers,
    });
  }

  GetCurrentUserPhoto(): Observable<UserPhoto> {
    return this.httpClient.get<UserPhoto>(this.GET_CURRENT_USER_PHOTO);
  }

  PutCurrentUserPhoto(photo: Blob): Observable<UserPhoto> {
    const formData: FormData = new FormData();
    formData.append("file", photo);
    return this.httpClient.put<UserPhoto>(
      this.PUT_CURRENT_USER_PHOTO,
      formData
    );
  }

  quitarPhoto(): Observable<string> {
    return this.httpClient.delete(environment.apiUrl + "a/r/f", {
      responseType: "text",
    });
  }

  GetCurrentUserMiniature(): Observable<UserPhoto> {
    return this.httpClient.get<UserPhoto>(this.GET_CURRENT_USER_MINIATURE_URL);
  }

  PutCurrentUserPassword(credencial: Credencial): Observable<Credencial> {
    return this.httpClient.put<Credencial>(
      this.PUT_CURRENT_USER_PASSWORD_URL,
      credencial
    );
  }

  GetCurrentUserSignatureData(): Observable<FirmaElectronica> {
    return this.httpClient.get<FirmaElectronica>(
      this.GET_CURRENT_USER_SIGNATURE_DATA_URL
    );
  }

  removeSignature(): Observable<FirmaElectronica> {
    return this.httpClient.delete<FirmaElectronica>(
      environment.apiUrl + "a/rfe/bsx"
    );
  }

  PatchCurrentUserSignatureData(
    signature: File,
    desc: string
  ): Observable<FirmaElectronica> {
    const formData: FormData = new FormData();
    formData.append("file", signature);
    formData.append("fileName", signature.name);
    formData.append("desc", desc);
    return this.httpClient.patch<FirmaElectronica>(
      this.PATCH_CURRENT_USER_SIGNATURE_URL,
      formData
    );
  }

  GetNotificarme(): Observable<{
  existe: boolean;
  estado: boolean | null;
} | null> {
  return this.httpClient
    .get<{ existe: boolean; estado: boolean | null }>(
      environment.apiUrl + "a/u/notificarme"
    )
    .pipe(
      catchError((err) => {
        console.error("Error al obtener notificarme:", err);
        return of(null);
      })
    );
}

  CreateNotificarme(dto: Partial<ListaCorreo>): Observable<ListaCorreo> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.httpClient.post<ListaCorreo>(
      environment.apiUrl + "a/u/notificarme",
      dto,
      { headers }
    );
  }

  UpdateNotificarme(dto: Partial<ListaCorreo>): Observable<ListaCorreo> {
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.httpClient.put<ListaCorreo>(
      environment.apiUrl + "a/u/notificarme",
      dto,
      { headers }
    );
  }
}
